import ViewCollection from "./ViewCollection";

export default ViewCollection